import PropTypes from "prop-types";
import React from "react";
// @mui
import { Stack, Typography } from "@mui/material";
// components
import { XDialog as Dialog, XDialogContent as DialogContent } from "src/components/template/popup";

// ----------------------------------------------------------------------

ErrorRow.propTypes = {
    variant: PropTypes.string,
    color: PropTypes.string,
    row: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string
};

function ErrorRow({ variant, color, row, title, message }) {
    return (
        <Stack direction="row" alignItems="flex-start">
            <Stack flex={ 1 }>
                <Typography variant={ variant } color={ color }>{ row }</Typography>
            </Stack>

            <Stack pl="32px" flex={ 2 }>
                <Typography variant={ variant } color={ color }>{ title }</Typography>
            </Stack>

            <Stack pl="37px" flex={ 4 }>
                <Typography variant={ variant } color={ color }>{ message }</Typography>
            </Stack>
        </Stack>
    );
}

// ----------------------------------------------------------------------

TaskErrorDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    detail: PropTypes.array
};

export default function TaskErrorDialog({ open, onClose, detail }) {
    return (
        <Dialog open={ open } onClose={ onClose }>
            <DialogContent>
                <Typography variant="h3" color="text.primary">Error Information</Typography>

                <Stack my="14px" pb="15px" sx={ { borderBottom: theme => `1px solid ${ theme.palette.line }` } }>
                    <ErrorRow variant="body2" color="text.primary" row="Error Row" title="Error Title" message="Error Message" />
                </Stack>

                <Stack spacing="14px">
                    { ( detail || [] ).map((error, index) => (
                        <ErrorRow key={ index } variant="body1" color="text.secondary" row={ error?.err_row ?? "" } title={ error?.err_title ?? "" } message={ error?.err_msg ?? "" } />
                    )) }
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
